import { Controller } from "@hotwired/stimulus"

// Contact form VIP quick-pick: selecting a tier fills the prior-spend amount
// input with that tier's threshold. Picker is a helper only (resets after fill);
// the amount field is the sole persisted value.
export default class extends Controller {
  static targets = ["picker", "amount"]

  fill() {
    if (this.pickerTarget.value) {
      this.amountTarget.value = this.pickerTarget.value
      // Setting .value programmatically fires no events — nudge the amount
      // field's money-input controller so the filled threshold gets grouped.
      this.amountTarget.dispatchEvent(new Event("input"))
    }
    this.pickerTarget.value = ""
  }
}
